import React, { useState, useCallback } from 'react'

import { isImage } from 'utils/Validations'
import { fileReader } from 'utils/FileUtils'
import { hasImgRightDimensions } from 'utils/ImageUtils'
import DropZoneFileUploaderUI from './DropZoneFileUploaderUI'

const DropZoneFileUploader = (props) => {
  const { height, maxSize, uploadFiles, onError, onHiddenDropZone } = props

  const [dragStatus, setDragStatus] = useState({
    infoMessage: 'composer_dragInfo_dropHere',
    error: null
  })

  const onDragOver = useCallback((event) => {
    event.preventDefault()
    event.stopPropagation()
  }, [])

  const hiddenDropZone = () => {
    if (typeof onHiddenDropZone === 'function') {
      onHiddenDropZone()
    }
  }

  const displayError = (error) => {
    if (typeof onError === 'function') {
      onError(error)
      hiddenDropZone()
    } else {
      setDragStatus(prevState => ({ ...prevState, error }))
    }
  }

  const resetError = () => {
    if (typeof onError === 'function') {
      onError('')
    } else {
      setDragStatus(prevState => ({ ...prevState, error: null }))
    }
  }

  const onDrop = async (event) => {
    event.preventDefault()
    event.stopPropagation()

    resetError()

    const files = event.dataTransfer.files

    if (files.length) {
      const finalFiles = []

      for (const file of files) {
        if (maxSize > 0 && file.size > maxSize) {
          displayError('file-too-big')

          return
        } else {
          if (isImage(file.type)) {
            const isPassed = await hasImgRightDimensions(
              file,
              { isTotalDimensions10Kpx: true }
            )

            if (!isPassed.isOk) {
              displayError(isPassed.message || '')

              return
            }
          }

          const parsedFile = {
            name: file.name,
            size: file.size,
            preview: file.preview,
            lastModified: file.lastModified,
            type: file.type,
            file,
          }

          parsedFile.preview = await fileReader(file)
          finalFiles.push(parsedFile)
        }
      }

      uploadFiles(finalFiles)
    }

    hiddenDropZone()
  }

  return (
    <DropZoneFileUploaderUI
      height={height}
      infoMessage={dragStatus.infoMessage}
      error={dragStatus.error}
      onDragOver={onDragOver}
      onDrop={onDrop}
    />
  )
}

export default DropZoneFileUploader
